import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { NkButton, NkForm, NkGroup } from '@/core/components';
import { useForm } from '@/core/hooks/forms';
import { PropType } from 'vue';
import { useDeleteInspectionImageMutation } from '@/entities/inspection-image/hooks';
import { InspectionImage } from '@/entities/inspection-image/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'InspectionImageDeleteForm',
  props: {
  id: {
    type: Number as PropType<InspectionImage['id']>,
    required: true,
  },
},
  emits: [],
  setup(__props, { emit: emits }) {

const props = __props


const {
  mutateAsync,
  error,
  isError,
} = useDeleteInspectionImageMutation();


const { onSubmitted } = useForm(emits);



const submit = () => {
  mutateAsync({ id: props.id })
    .then((data) => {
      onSubmitted(data);
    });
};


return (_ctx: any,_cache: any) => {
  const _component_ElAlert = _resolveComponent("ElAlert")!
  const _component_el_alert = _resolveComponent("el-alert")!

  return (_openBlock(), _createBlock(_unref(NkForm), null, _createSlots({
    footer: _withCtx(() => [
      _createVNode(_unref(NkGroup), { position: "right" }, {
        default: _withCtx(() => [
          _createVNode(_unref(NkButton), {
            type: "danger",
            onClick: submit
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('actions.delete')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_alert, {
        closable: false,
        description: props.id,
        title: _ctx.$t('forms.delete.warning'),
        effect: "dark",
        type: "error"
      }, null, 8, ["description", "title"])
    ]),
    _: 2
  }, [
    (_unref(isError))
      ? {
          name: "header",
          fn: _withCtx(() => [
            _withDirectives(_createVNode(_component_ElAlert, {
              "show-icon": "",
              type: "error"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(error)?.response?.data?.message || _unref(error)), 1)
              ]),
              _: 1
            }, 512), [
              [_vShow, _unref(isError)]
            ])
          ])
        }
      : undefined
  ]), 1024))
}
}

})